<template>
  <div class="List" @click="removeUserPopup">
    <!-- header -->
    <main-header/>
    <!-- s: contents -->
    <div class="contents-container">
      <div class="mrg-top-15 mrg-btm-10 pdd-horizon-20"
           :style='{height:`${swiperHeight}px`}'
           v-if="bannerList.length > 0">
        <mt-swipe :auto="4000">
          <mt-swipe-item v-for="item in bannerList"
                         :key="item.nBannerNum">
            <a>
              <img :src="item.strBannerUrl" width="100%" @load="imgLoad"/>
            </a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="contents-area"
           v-infinite-scroll="getBoardList"
           infinite-scroll-disabled="loading"
           infinite-scroll-distance="300">
        <div class="boardList-tab-area">
          <div class="boardList-tab">
            <ul v-if="menuType=='community'">
              <li v-for="item in communityBoardList"
                  :key="item.nMenuNum"
                  :class="item.nMenuNum == activeBoardList ? 'active' : ''">
                <a :class="{ disabled : (item.bAllowAccessMenu == false) }"
                   @click="boardTypeTab(item.nMenuNum, item.bAllowAccessMenu)"
                >
                  {{ item.strMenuName }}
                </a>
              </li>
            </ul>
            <ul v-else>
              <li v-for="item in serviceCenterBoardList"
                  :key="item.nMenuNum"
                  :class="item.nMenuNum == activeBoardList ? 'active' : ''">
                <a :class="{ disabled : (item.bAllowAccessMenu == false) }"
                   @click="boardTypeTab(item.nMenuNum, item.bAllowAccessMenu)"
                >
                  {{ item.strMenuName }}
                </a>
              </li>
            </ul>
          </div>
          <div class="boardList-menu-area"
               @click="menuPopup = true">
            <img src="@/assets/images/icon-menu.png" width="100%"/>
          </div>
          <div class="boardList-menu-popup"
               :class="{'active':menuPopup}">
            <div class="boardList-menu-popup-area">
              <h2>
                전체보기
                <button class="ir boardList-menu-popup-close"
                        @click="menuPopup = false">
                  닫기
                </button>
              </h2>
              <ul v-if="menuType=='community'">
                <li :class="['popup-menu-home'+item.nMenuNum, (item.bAllowAccessMenu == false) ? 'disabled' : item.nMenuNum == activeBoardList ? 'active' : '']"
                    v-for="item in communityBoardList"
                    :key="item.nMenuNum">
                  <a @click="boardTypeTab(item.nMenuNum, item.bAllowAccessMenu)">{{ item.strMenuName }}</a>
                </li>
              </ul>
              <ul v-else>
                <li :class="['popup-menu-home'+item.nMenuNum, item.nMenuNum == activeBoardList ? 'active' : '']"
                    v-for="item in serviceCenterBoardList"
                    :key="item.nMenuNum">
                  <a @click="boardTypeTab(item.nMenuNum, item.bAllowAccessMenu)">{{ item.strMenuName }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="boardList-list-type" @click="boardMagazineView">
            <img src="@/assets/images/icon-board-magazine.png"
                 width="100%"
                 v-if="magazineYn"/>
            <img src="@/assets/images/icon-board-list-type.png"
                 width="100%"
                 v-else/>
          </div>
        </div>
        <div class="pdd-top-55">
          <!-- 카테고리 검색 -->
          <div class="mrg-top-60" v-if="boardCategory.length>0">
            <select class="width-100" v-model="nCategoryNum" @change="searchCombo">
              <option value="">분류선택</option>
              <option v-for="item in boardCategory"
                      :key="item.nCategoryNum"
                      :value="item.nCategoryNum">
                {{ item.strCategoryName }}
              </option>
            </select>
          </div>
          <!-- 지역 검색 -->
          <div class="mrg-top-10" v-if="boardRegion.length>0">
            <select class="width-100" v-model="nRegionNum" @change="searchCombo">
              <option value="">지역선택</option>
              <option v-for="item in boardRegion"
                      :key="item.nRegionNum"
                      :value="item.nRegionNum">
                {{ item.strRegionName }}
              </option>
            </select>
          </div>
          <!-- 지역 검색 -->
          <div class="mrg-top-15 no-pdd-top" v-if="bSearchMode">
            <select v-model="strSearchMode" class="mrg-btm-15">
              <option value="content">제목 + 내용</option>
              <option value="title">제목</option>
              <option value="user">작성자</option>
            </select>
            <div class="search-area">
              <input type="text" placeholder="검색어를 입력하세요." v-model="strSearch"/>
              <button class="ir btn-input-del" @click="strSearch=''">초기화</button>
              <button class="ir btn-search" @click="searchBoard">검색</button>
            </div>
          </div>

          <div class="boardList boardFixd clearfix">
            <ul>
              <li v-for="data in boardNoticeList"
                  :key="data.oBoard.nBoardIdx"
                  class="mrg-top-10"
              >
                <board-top-fix-style :data="data"/>
              </li>
              <li v-for="data in boardTopFixList"
                  :key="data.oBoard.nBoardIdx"
                  class="mrg-top-10"
              >
                <board-top-fix-style :data="data"/>
              </li>
            </ul>
          </div>
          <div class="boardMagazine mrg-top-10" v-if="magazineYn">
            <ul>
              <li v-for="data in boardNormalList"
                  :key="data.oBoard.nBoardIdx"
                  :style="'background-image: url('+data.oBoard.strThumbUrl+')'"
                  :class="'bgcolor-'+ (Math.floor(Math.random() * 5) + 1) "
                  @click="boardDetailMove(activeBoardList, data.oBoard.nBoardNum, data.oBoard.oAuthorizeAccessRead)">
                <div class="boardMagazine-area" :class="(data.oBoard.strThumbUrl) ? 'bg-dim' : ''">
                  <h3 :class="{ bUserBlockY: !data.oBoard.oAuthorizeAccessRead.bAuthorizeAccess }">
                    {{ data.oBoard.strBoardTitle }}
                  </h3>
                  <div v-if="data.oUser || data.oBoard" class="userPopupInfo">
                                        <span class="name"
                                              v-if="data.oUser"
                                              @click.stop="userPopupToggleClass($event,'on')"
                                        >
                                            {{ data.oUser.strNickName }}
                                            <board-user-popup :data.sync="data"/>
                                        </span>
                    <span v-if="data.oBoard">
                                            {{ data.oBoard.strRegDate | moment("YY.MM.DD") }}
                                        </span>
                  </div>
                  <div>
                                        <span class="readcnt mrg-right-10"
                                              v-if="data.oBoard">
                                            {{ data.oBoard.nViewCnt | comma }}
                                        </span>
                    <span class="like" v-if="data.oBoard && data.oBoard.nRecomCnt">{{
                        data.oBoard.nRecomCnt | comma
                      }}</span>
                  </div>
                  <div v-if="data.oBoard">
                    <span class="comment">{{ data.oBoard.nReplyCnt | comma }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 썸네일 게시판일 경우 board-thumb 클래스 추가 -->
          <div class="boardList clearfix mrg-top-10"
               v-else
               :class="strBoardStyle == 'GALLERY' ? 'board-thumb' : ''">
            <ul>
              <!-- 일반 게시판일 경우 -->
              <li v-for="data in boardNormalList"
                  :key="data.oBoard.nBoardIdx"
                  :class="data.oBoard.strAtclType">
                <!-- GALLERY 스타일 -->
                <board-gallery-style
                    v-if="strBoardStyle == 'GALLERY'"
                    :data.sync="data"/>

                <!-- GALLERY 스타일 -->
                <board-event-style
                    v-else-if="strBoardStyle == 'EVENT_BANNER'"
                    :data.sync="data"/>

                <!-- 일반 스타일 -->
                <board-list-style
                    v-else :data.sync="data"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- e: contents -->
    <!-- s: footer -->
    <footer class="footer-board">
      <ul>
        <li><a @click="homeMove"><img src="../../assets/images/bottom-tab-home.png"/></a></li>
        <li><a @click="boardListReload"><img src="../../assets/images/bottom-tab-refresh.png"/></a></li>
        <li><a @click="boardTop"><img src="../../assets/images/bottom-tab-top.png"/></a></li>
        <li><a @click="boardSearchSlideView"><img src="../../assets/images/bottom-tab-search.png"/></a></li>
        <li><a @click="boardWriteAuthCheck('')"><img src="../../assets/images/bottom-tab-write.png"/></a></li>
      </ul>
    </footer>
    <!-- e: footer -->
  </div>
</template>

<script>
import mainHeader from '@/components/mainHeader.vue';
import BoardTopFixStyle from "@/components/boardTopFixStyle";
import BoardListStyle from "@/components/boardListStyle";
import BoardGalleryStyle from "@/components/boardGalleryStyle";
import BoardEventStyle from "@/components/boardEventStyle";
import EventBus from "@/plugins/eventBus";
import BoardUserPopup from "@/components/boardUserPopup";

export default {
  name: 'List',
  components: {BoardUserPopup, BoardTopFixStyle, BoardEventStyle, BoardGalleryStyle, BoardListStyle, mainHeader},
  data() {
    return {
      nCategoryNum: '',
      nRegionNum: '',
      menuType: ([9999, 4, 36].includes(this.storageGet('vuex', 'boardActiveCode'))) ? 'serviceCenter' : 'community', // 메뉴 구분 (커뮤니티, 고객센터)
      activeBoardList: this.storageGet('vuex', 'boardActiveCode'),  // 선택된 게시글
      menuPopup: false,            // 전체메뉴 레이어팝업 여부
      swiperHeight: 0,             // 배너 높이설정
      bannerList: [],              // 배너리스트
      boardNoticeList: [],         // 공지사항 게시글
      boardTopFixList: [],         // 상단고정 게시글
      boardNormalList: [],         // 게시글리스트
      strBoardStyle: 'LIST',       // 게시판UI스타일
      bSearchMode: false,          // 검색모드
      strSearchMode: 'content',    // 검색모드 ( title :: 제목, content :: 제목+내용, user::사용자아이디)
      strSearch: '',               // 검색어
      boardCategory: {},           // 각 게시판별 카테고리 번호 ( 전체 게시글을 확인할 땐.. 0 으로 전달 )
      boardRegion: {},             // 지역 정보 ( 거래처 찾기, 부동상 게시판에 넘겨주는 지역정보의 고유번호를 넘겨준다.  전체 게시글을 확인할 땐.. 0 으로 전달.)
      page: 1,                     // 페이지번호
      loading: false,              // 로딩여부
      listMore: true,              // infinite 종료여부
      magazineYn: this.storageGet('magazineYn') ? this.storageGet('magazineYn') : false         // 매거진 형태, 게시글 형태
    }
  },
  // 계산된 속성
  computed: {
    // 커뮤니티 카테고리 리스트
    communityBoardList: function () {
      let boardChild = [];
      this.$store.state.boardList.community.child.forEach(function (item) {
        boardChild.push(item)
      })
      return boardChild;
    },
    // 고객센터 카테고리 리스트
    serviceCenterBoardList: function () {
      let boardChild = [];
      this.$store.state.boardList.serviceCenter.child.forEach(function (item) {
        boardChild.push(item)
      })
      return boardChild;
    }
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
    this.loginCheck();
    // 게시글 새로고침
    EventBus.$off('reload-board-list');
    EventBus.$on('reload-board-list', () => {
      this.boardListReload();
    });
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
    this.$nextTick(function () {
      // 좌측메뉴에서 선택 시 탭 위치 이동
      if (this.activeBoardList) {
        let boardTypePosition = document.querySelector('.boardList-tab li.active').offsetLeft;
        document.querySelector('.boardList-tab').scrollLeft = boardTypePosition - 250;
      }
      this.getBoardList();
      this.getCategoryList(this.activeBoardList);
    });
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {
      let history = this.$store.state.historyUrl;
      history.pop();
      if (history.length > 0) {

        this.menuType = ([9999, 4, 36].includes(history[history.length - 1])) ? 'serviceCenter' : 'community'

        this.boardTypeTab(history[history.length - 1])
        this.getBoardList();
        history.pop();
        this.$store.commit('setHistoryUrl', history);
      } else {
        this.$router.push('/Main').catch(this.routerCatchError)
      }
    },
    // 초기화
    boardListReload() {
      this.bannerList = [];
      this.boardNoticeList = [];
      this.boardTopFixList = [];
      this.boardNormalList = [];
      this.menuPopup = false;
      this.nCategoryNum = '';
      this.bSearchMode = false;
      this.strSearchMode = 'content';
      this.strSearch = '';
      this.page = 1;
      this.loading = false;
      this.listMore = true;
      this.getCategoryList(this.storageGet('vuex', 'boardActiveCode'));
      this.getBoardList();
    },
    // 게시글 검색
    searchBoard() {
      this.bannerList = [];
      this.boardNoticeList = [];
      this.boardTopFixList = [];
      this.boardNormalList = [];
      this.page = 1;
      this.loading = false;
      this.listMore = true;
      this.getBoardList();
    },
    // 카테고리 리스트
    getCategoryList(code) {
      let param = {};
      this.ajaxGetAuth('/api/v1/category/list/' + code, param, this.getCategoryListResult);
    },
    // 카테고리 리스트 결과
    getCategoryListResult(response) {
      this.nCategoryNum = '';
      this.nRegionNum = '';
      if (response.result.code == 0) {
        this.boardCategory = response.oCategoryInfo.list;
        this.boardRegion = response.oRegionInfo.list;
      } else {
        this.boardCategory = {};
        this.boardRegion = {};
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
    },
    // 매거진 형태로 ui 변경
    boardMagazineView() {
      if (this.magazineYn === true) {
        this.magazineYn = false;
        this.storageSet('magazineYn', false)
      } else {
        this.magazineYn = true;
        this.storageSet('magazineYn', true)
      }

    },
    // 게시글
    getBoardList() {
      if (this.listMore === false) {
        return false;
      }

      this.loading = true;
      let param = {};
      param.nPage = this.page++;
      param.nCategoryNum = this.nCategoryNum;
      param.nRegionNum = this.nRegionNum;
      if (this.bSearchMode) {
        param.strSearchMode = this.strSearchMode;
        param.strSearch = this.strSearch;
      }

      this.ajaxGetAuth('/api/v1/board/list/' + this.activeBoardList, param, this.getBoardListResult);
    },
    // 게시글 결과
    getBoardListResult(response, varParam) {
      // let result = response;
      if (response.result.code === "0") {
        let vm = this;
        if (varParam.nPage === 1) {
          // 배너리스트
          response.oBannerInfo.list.forEach(function (key) {
            vm.bannerList.push(key)
          })
        }

        // 게시글 리스트
        response.oBoardInfo.list.forEach(function (key) {
          // 공지사항 게시글
          if (key.oBoard.strAtclType === 'NOTICE') {
            vm.boardNoticeList.push(key)
            // 상단고정 게시글
          } else if (key.oBoard.strAtclType === 'TOP_FIX') {
            vm.boardTopFixList.push(key)
            // 일반 게시글
          } else {
            vm.boardNormalList.push(key)
          }
        })

        this.strBoardStyle = response.oBoardInfo.setting.strBoardStyle
        this.bSearchMode = response.oBoardInfo.setting.bSearchMode

        // 현재 페이지와 마지막 페이지가 같은경우
        if (response.oBoardInfo.setting.nNowPage === response.oBoardInfo.setting.nMaxPage) {
          this.listMore = false;
        }

      }
      else {
        if (response.result.resultNoti.type === 'alert') {
          this.toastMsg(response.result.resultNoti.message, 1500)
        } else {
          this.errorMsg = response.result.resultNoti.message;
          this.errorField = response.result.resultNoti.validationFail.id;
        }
        this.listMore = false;
      }
      this.loading = false;
    },
    // 게시글 tab 선택
    boardTypeTab(code, accessMenu = false) {

      if (!accessMenu) {
        this.toastMsg('상품구매 후 이용이 가능합니다', 1500)
        return false
      }

      if (this.loading) {
        this.toastMsg('게시글을 불러오는 중입니다. 잠시만 기다려주세요.', 1500)
        return false;
      }

      this.activeBoardList = code;
      this.gotoHistoryUrl(code);
      this.bannerList = [];
      this.boardNoticeList = [];
      this.boardTopFixList = [];
      this.boardNormalList = [];
      this.menuPopup = false;
      this.nCategoryNum = '';
      this.bSearchMode = false;
      this.strSearchMode = 'content';
      this.strSearch = '';
      this.page = 1;
      this.loading = false;
      this.listMore = true;
      this.getBoardList();
      this.getCategoryList(code)
    },
    // 각 게시판별 카테고리 선택
    searchCombo() {
      this.bannerList = [];
      this.boardNoticeList = [];
      this.boardTopFixList = [];
      this.boardNormalList = [];
      this.menuPopup = false;
      this.loading = false;
      this.listMore = true;
      this.page = 1;
      this.getBoardList();
    },
    // 홈으로 이동
    homeMove() {
      this.gotoLink('/Main')
    }
  },
  // $el 해체
  destroyed() {
  }
}
</script>

<style scoped>
.boardList-tab-area {
  margin: 0 -20px;
  padding: 0 70px 0 20px;
  border-bottom: 1px solid #dfdfdf; /*margin-bottom: 10px;position: relative*/
}

.boardList-tab-area {
  position: fixed;
  z-index: 100;
  background: #fff;
  top: 60px;
  left: 20px;
  right: 20px;
}

.boardList-tab {
  padding-bottom: 10px;
}

.boardList-menu-area {
  position: absolute;
  right: 47px;
  top: 11px;
  width: 20px;
  height: 20px;
}

.boardList-menu-popup-close {
  position: absolute;
  right: 10px;
  top: 18px;
  width: 20px;
  height: 20px;
  background-image: url("../../assets/images/btn-hamburger-close.png");
  background-repeat: no-repeat;
  background-size: 25px;
  background-position: center;
}

.boardList-menu-popup {
  display: none;
}

.boardList-menu-popup.active {
  display: block;
}

.boardList-menu-popup:before {
  content: "";
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.boardList-menu-popup-area {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 0px;
  background: #fff;
  z-index: 11;
  border-radius: 10px;
  padding: 10px
}

.boardList-menu-popup-area h2 {
  border-bottom: 1px solid #e0e0e0;
  color: #000;
  padding: 10px 15px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 -10px 10px;
}

.boardList-menu-popup-area ul {
  text-align: center;
}

.boardList-menu-popup-area ul li { /*width: 90px;*/
  width: 28%;
  height: 60px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: center top 6px;
  border: 1px solid #e0e0e0;
  text-align: center;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 90px;
  margin-right: 7px;
  margin-bottom: 7px;
  position: relative
}

.boardList-menu-popup-area ul li.popup-menu-home {
  background-image: url("../../assets/images/icon_hom_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home1 {
  background-image: url("../../assets/images/icon_jongsaja_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home3 {
  background-image: url("../../assets/images/icon_jayu_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home5 {
  background-image: url("../../assets/images/icon_singo_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home8 {
  background-image: url("../../assets/images/icon_fun_off.png");
  background-size: 22px;
  background-position: center top 8px;
}

.boardList-menu-popup-area ul li.popup-menu-home10 {
  background-image: url("../../assets/images/icon_junggo_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home12 {
  background-image: url("../../assets/images/icon_budongsan_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home9 {
  background-image: url("../../assets/images/icon_geolaecheo_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home13 {
  background-image: url("../../assets/images/icon_ibenteu_off.png");
}

.boardList-menu-popup-area ul li.popup-menu-home33 {
  background-image: url("../../assets/images/icon_data_off.png");
  background-size: 27px;
  background-position: center top 10px;
}

.boardList-menu-popup-area ul li.popup-menu-home9999 {
  background-image: url("../../assets/images/icon_faq_off.png");
  background-size: 25px;
  background-position: center top 10px;
}

.boardList-menu-popup-area ul li.popup-menu-home4 {
  background-image: url("../../assets/images/icon_question_off.png");
  background-size: 25px;
  background-position: center top 10px;
}

.boardList-menu-popup-area ul li.popup-menu-home36 {
  background-image: url("../../assets/images/icon_notice_off.png");
  background-size: 25px;
  background-position: center top 8px;
}

.boardList-menu-popup-area ul li.active {
  background-color: #2e9cff;
  border: 1px solid #2e9cff;
}

.boardList-menu-popup-area ul li.active a {
  color: #fff;
}

.boardList-menu-popup-area ul li.popup-menu-home.active {
  background-image: url("../../assets/images/icon_hom_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home1.active {
  background-image: url("../../assets/images/icon_jongsaja_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home3.active {
  background-image: url("../../assets/images/icon_jayu_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home5.active {
  background-image: url("../../assets/images/icon_singo_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home8.active {
  background-image: url("../../assets/images/icon_fun_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home10.active {
  background-image: url("../../assets/images/icon_junggo_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home12.active {
  background-image: url("../../assets/images/icon_budongsan_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home9.active {
  background-image: url("../../assets/images/icon_geolaecheo_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home13.active {
  background-image: url("../../assets/images/icon_ibenteu_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home33.active {
  background-image: url("../../assets/images/icon_data_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home9999.active {
  background-image: url("../../assets/images/icon_faq_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home4.active {
  background-image: url("../../assets/images/icon_question_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home36.active {
  background-image: url("../../assets/images/icon_notice_on.png");
}

.boardList-menu-popup-area ul li.popup-menu-home.disabled {
  background-image: url("../../assets/images/icon_hom_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home1.disabled {
  background-image: url("../../assets/images/icon_jongsaja_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home3.disabled {
  background-image: url("../../assets/images/icon_jayu_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home5.disabled {
  background-image: url("../../assets/images/icon_singo_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home8.disabled {
  background-image: url("../../assets/images/icon_fun_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home10.disabled {
  background-image: url("../../assets/images/icon_junggo_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home12.disabled {
  background-image: url("../../assets/images/icon_budongsan_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home9.disabled {
  background-image: url("../../assets/images/icon_geolaecheo_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home13.disabled {
  background-image: url("../../assets/images/icon_ibenteu_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home33.disabled {
  background-image: url("../../assets/images/icon_data_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home9999.disabled {
  background-image: url("../../assets/images/icon_faq_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home4.disabled {
  background-image: url("../../assets/images/icon_question_disabled.png");
}

.boardList-menu-popup-area ul li.popup-menu-home36.disabled {
  background-image: url("../../assets/images/icon_notice_disabled.png");
}

.boardList-menu-popup-area ul li.disabled a {
  color: #ccc;
}

.boardList-menu-popup-area ul li a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.boardList-menu-popup-area ul li a img {
}

.boardList-list-type {
  position: absolute;
  right: 20px;
  top: 11px;
  width: 20px;
  height: 20px;
}

select {
  height: 40px;
}

</style>
